
import React, { useState } from "react";
import { DocumentProps } from "@/hooks/admin/identity-docs/useSubmittedDocuments";
import { DocumentDeleteDialog } from "./DocumentDeleteDialog";
import { DocumentViewButton } from "./actions/DocumentViewButton";
import { useIsMobile } from "@/hooks/use-mobile";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Trash2 } from "lucide-react";

interface DocumentActionsSimplifiedProps {
  document: DocumentProps;
  onDocumentUpdated?: () => void;
}

export function DocumentActionsSimplified({ document, onDocumentUpdated }: DocumentActionsSimplifiedProps) {
  const isMobile = useIsMobile();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const handleDeleteDialogOpen = () => {
    setDropdownOpen(false);
    setDeleteDialogOpen(true);
  };

  return (
    <>
      <div className={`flex items-center ${isMobile ? 'gap-1' : 'gap-2'}`}>
        <DocumentViewButton 
          document={document} 
          variant="outline" 
          size={isMobile ? "sm" : "sm"}
          showText={!isMobile}
        />

        <DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
          <DropdownMenuTrigger asChild>
            <div 
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-8 w-8 cursor-pointer"
              role="button"
              tabIndex={0}
            >
              <span className="sr-only">Open menu</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem 
              onClick={handleDeleteDialogOpen}
              className="text-destructive"
            >
              <Trash2 className="mr-2 h-4 w-4" />
              <span>Delete Document</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <DocumentDeleteDialog
        document={document}
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        onDocumentDeleted={onDocumentUpdated}
      />
    </>
  );
}
